import { useEffect, useRef } from "react";

export function BackgroundVideo() {
  const videoRef = useRef<HTMLVideoElement>(null);
  useEffect(() => {
    const video = videoRef.current;

    // Prevent pausing by immediately playing again
    const handlePause = () => {
      try {
        video?.play();
      } catch (e) {
        console.error("Error while playing video: ", e);
      }
    };

    // Ensure video starts playing
    const handleLoadedData = () => {
      try {
        video?.play();
      } catch (e) {
        console.error("Error while playing video: ", e);
      }
    };

    if (video) {
      video.addEventListener("pause", handlePause);
      video.addEventListener("loadeddata", handleLoadedData);
    }

    return () => {
      if (video) {
        video.removeEventListener("pause", handlePause);
        video.removeEventListener("loadeddata", handleLoadedData);
      }
    };
  }, []);

  return (
    <div className="video-container">
      <video playsInline autoPlay muted loop ref={videoRef}>
        <source src="https://d1mdu1cxiv2wrk.cloudfront.net/nyc/video/video2.mp4"></source>
      </video>
    </div>
  );
}
